import { render } from "./FormField.vue?vue&type=template&id=9986265a"
import script from "./FormField.vue?vue&type=script&lang=js"
export * from "./FormField.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/vhosts/localhost/storage/app/public/zarihi-site/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__